$(function () {
    if ($(".page--product-selector").length != 0) {
        var calculatePoints = function calculatePoints() {
            var totalpoints = 0;
            $('.quantity-input').each(function () {
                var min = parseInt($(this).attr('min'));
                var max = parseInt($(this).attr('max'));
                var factor = $(this).attr('factor');
                var selectedValue = $(this).val();

                if (selectedValue < min) {
                    selectedValue = min;
                }

                if (selectedValue > max) {
                    selectedValue = max;
                }

                totalpoints += dataTable[factor][selectedValue];
            });
            var usage_showerflow = parseInt($("#usage_showerflow").val());
            var water_people = parseInt($("#water_people").val());
            var usage_baths_value = parseInt($("#usage_baths").val());
            var map_points = parseInt($('.zone-option:checked').val());
            totalpoints += usage_showerflow * water_people + usage_baths_value + map_points;
            $('#energy-calc').val(totalpoints);
            //console.log(totalpoints);
           /* if (totalpoints > 100) {
                $('.result-container').html("\n                <div class=\"error-label margin-top-40\">Your requirements exceed the average usage for our domestic products. You should consider installing 2 or more Rheem Water Heaters or upsizing to one of our Rheem Commercial Water Heaters.<br/>Call Rheem on 0800 657 336 to discuss the best option for you.</div>");
            } else {
                filterProducts();
            }*/
        };

        var filterProducts = function filterProducts() {
            var formData = $("#dataForm").serialize();
            var url = $("#dataForm").attr('action') + "?" + formData;
            $.ajax({
                url: url,
                dataType: 'json'
            }).done(function (data) {
                var html = "";

                for (var i = 0; i < data.length; i++) {
                    var category = data[i];
                    var modelHtml = "";

                    for (var j = 0; j < category.Models.length; j++) {
                        var model = category.Models[j];
                        var dataModel = JSON.stringify(model);
                        modelHtml += "\n                                <div class=\"col-md-4 product-container\">\n                                    <a href=\"" + model.Link + "\" class=\"model-link\">\n                                        <div class=\"img-container txt-center\">\n                                            <img alt=\"" + model.Name + "\" src=\"" + model.PhotoURL + "\">\n                                        </div>\n                                        <div class=\"text-container\">\n                                            " + model.Name + "\n                                        </div>\n                                    </a>\n                                    <div class=\"checkbox-input margin-top-10\">\n                                        <input id=\"compare-" + model.ID + "\" type=\"checkbox\" class=\"checkbox css-checkbox compare-model-checkbox\" data-id='" + model.ID + "' data-model='" + dataModel + "'>\n                                        <label for=\"compare-" + model.ID + "\" class=\"body-copy custom-checkbox css-label\">Add to compare</label>\n                                    </div>\n                                </div>";
                    }

                    html += "<div class=\"margin-top-40\">\n                            <h2>" + category.Name + "</h2>\n                            <div class=\"row\">" + modelHtml + "</div></div>";
                }

                $('.result-container').html(html);
                updateCompareUI();
            }).fail(function (err) {
                console.log(err);
            });
        };

        var dataTable = {
            water_people: {
                "0": 6,
                "1": 6,
                "2": 12,
                "3": 18,
                "4": 24,
                "5": 30,
                "6": 36,
                "7": 42,
                "8": 48,
                "9": 54
            },
            water_baths: {
                "0": 0,
                "1": 10,
                "2": 20,
                "3": 30
            },
            water_teenagers: {
                "0": 0,
                "1": 3,
                "2": 6,
                "3": 9,
                "4": 12
            },
            home_baths: {
                "1": 0,
                "2": 0,
                "3": 18,
                "4": 36
            },
            home_bedrooms: {
                "0": 0,
                "1": 0,
                "2": 0,
                "3": 0,
                "4": 6,
                "5": 12,
                "6": 18
            }
        };
        $('.factor-input').change(function () {
            calculatePoints();
        });
        $('.mapzone').click(function () {
            var zone = $(this).attr('zone');
            $('.zonelegend--zone' + zone).click();
        });
        $('.zonelegend').click(function () {
            $('.zonelegend').removeClass('active');
            $(this).addClass('active'); //calculatePoints();
        });
        /*$(".find-btn").click(function () {
            calculatePoints();
        });*/
        calculatePoints();
        $('.step-btn').click(function () {
            if (!$(this).hasClass('active')) {
                var stepIndex = parseInt($(this).attr('step'));
                $('.step-btn').removeClass('active');
                $('.step-btn').removeClass('completed');

                for (var i = 1; i <= 4; i++) {
                    if (i < stepIndex) {
                        $('.step-btn[step="' + i + '"]').addClass('completed');
                    }

                    if (i == stepIndex) {
                        $('.step-btn[step="' + i + '"]').addClass('active');
                    }
                }

                $('.form-filter-row').hide();
                $('.form-filter-row[step="' + stepIndex + '"]').show();

                if (screen.width < 500) {
                    $('.form-filter-group').hide();
                    $('.form-filter-group[step="' + stepIndex + '"]').show();
                } else {
                    $('.form-filter-group').hide();
                    $('.form-filter-group[step="' + stepIndex + '"]').show();
                }

                if (stepIndex == 1) {
                    $(".prev-btn").hide();
                } else {
                    $(".prev-btn").show();
                }

                if (stepIndex == 4) {
                    $(".next-btn").hide();
                    $(".find-btn").show();
                } else {
                    $(".next-btn").show();
                    $(".find-btn").hide();
                }
            }
        });
        $('.compare-checkbox').change(function () {
            var size = $('.compare-checkbox:checked').length;

            if (size > 3) {
                $(this).prop('checked', false);
                toast('Maximum number of compared products added');
                return;
            }

            if (size < 2) {
                $('.compare-product-button').addClass('disabled');
            } else {
                $('.compare-product-button').removeClass('disabled');
            }

            $('.compare-product-button').html('Compare products (' + size + ')');

            if (size > 0) {
                if (size == 1) {
                    $('.fixed-compare-product-txt').html('Add to compare 1 or 2 more products');
                } else {
                    $('.fixed-compare-product-txt').html('');
                }

                $(".fixed-compare-btn-panel").show();
            } else {
                $(".fixed-compare-btn-panel").hide();
            }
        });
        $('.compare-product-button').click(function () {
            if ($('.compare-checkbox:checked').length > 1) {
                var checkedItems = '';
                $('.compare-checkbox:checked').each(function () {
                    checkedItems += $(this).attr('data-id') + '-';
                });
                checkedItems = checkedItems.slice(0, -1);
                location.href = 'compare/' + checkedItems;
            }
        });
        $('.filter-option').click(function () {
            var dataFilter = $(this).attr('data-filter');
            $('.filter-option').removeClass('active');
            $(this).addClass('active');

            if (dataFilter == 'all') {
                $('.category-group').show();
            } else {
                $('.category-group').hide();
                $('.' + dataFilter).show();
            }

            if ($('.category-group:visible').length == 0) {
                $('.no-result-container').show();
            } else {
                $('.no-result-container').hide();
            }
        });
        $('.prev-btn').click(function (e) {
            e.preventDefault();
            $('.step-btn.active').prev().click();
        });
        $('.next-btn').click(function (e) {
            e.preventDefault();
            $('.step-btn.active').next().click();
        });
        $('.disclaimer-link').click(function (e) {
            e.preventDefault();

            if ($(this).hasClass('active')) {
                $(this).removeClass('active');
                $('.disclaimer-detail').slideUp();
            } else {
                $('.disclaimer-link').addClass('active');
                $('.disclaimer-detail').slideDown();
            }
        });
        $('.filter-option').eq(0).click();
        $('.step-btn').eq(0).click();
        updateCompareUI();

        if ($(".slick-seed").length) {
            if (screen.width < 400) {
                $(".slick-seed").addClass('slick-slider');
                $(".slick-slider").slick({
                    slidesToShow: 1,
                    infinite: true,
                    nextArrow: '<div class="slider-btn slider-next "><span class="grand-icon icon-arrow"></span></div>',
                    prevArrow: ''
                });
            }
        }
    }
});